import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BitfDynamicLocaleService } from '@common/libs/bitforce/core/services/locale/bitf-dynamic-locale.service';
import { RouteTranslatorService } from '@web/core/services';

@Component({
  selector: 'ala-announcement-bar',
  templateUrl: './announcement-bar.component.html',
  styleUrls: ['./announcement-bar.component.scss'],
})
export class AnnouncementBarComponent implements OnInit {
  constructor(
    public router: Router,
    public routeTranslator: RouteTranslatorService,
    public bitfDynamicLocaleService: BitfDynamicLocaleService
  ) {}

  ngOnInit(): void {}

  onChangeLanguage(langCode: 'it' | 'en') {
    this.router.navigate(['/', langCode]);
  }
}
